export class deliveredUrl {
    ACCESS_LINK_URL = "ssr/v2/delivered-return/{taxReturnId}/access-link";
    ARCHIVE_RETURN_URL = "ssr/v2/delivered-return/archive";
    DELETE_RETURN_URL = "ssr/v2/delivered-return/";
    DELIVERED_RETURN_URL = "ssr/v2/delivered-return/all[?ClientId][&ClientName][&TaxYear][&ERO][&SignatureStatus][&Drafttatus][&EngagementType][&DeliveredAfter][&PageSize][&PageNumber][&SortBy][&SortOrder]";
    E_FILE_FORMS_URL = "ssr/v2/delivered-return/{taxReturnId}/efile-forms";
    RECALL_RETURN_URL = "ssr/v2/delivered-return/recall";
    RESEND_ACCESS_LINK_URL = "ssr/v2/delivered-return/resend-access-link";
    SEND_REMINDER_URL = "ssr/v2/delivered-return/send-reminder";
    SIGNATURE_STATUS_URL = "ssr/v2/delivered-return/{taxReturnId}/signature-status";
    SIGNER_INFORMATION_URL = "ssr/v2/delivered-return/{taxReturnId}/signer-info";
}

